export { BankExternalQr } from './bank-external-qr';
